import React from 'react'
import GPMS_Pro_detail1 from './GPMS_Pro_detail1'
import GPMS_Pro_detail2 from './GPMS_Pro_detail2'
import GPMS_Pro_detail3 from './GPMS_Pro_detail3'
import GPMS_Pro_detail4 from './GPMS_Pro_detail4'
import GPMS_Pro_detail5 from './GPMS_Pro_detail5'
// import GPMS_Pro_detail6 from './GPMS_Pro_detail6'
import GPMS_Pro_detail7 from './GPMS_Pro_detail7'
import GPMS_Pro_detail8 from './GPMS_Pro_detail8'
// import GPMS_Pro_detail9 from './GPMS_Pro_detail9'
// import GPMS_Pro_detail10 from './GPMS_Pro_detail10'
// import GPMS_Pro_detail11 from './GPMS_Pro_detail11'
import Gfooter from '../Component/Gfooter'
import GPMS_Pro_detail12 from './GPMS_Pro_detail12'
import GPMS_Pro_detail13 from './GPMS_Pro_detail13'
import GPMS_Pro_detail22 from './GPMS_Pro_detail22'
import GPMS_hero from './GPMS_hero'
import GPMS_Challenge from './GPMS_Challenge'
// import GPMS_Solution from './GPMS_Solution'
import GPMSPage from "../Component/GPMS/Gpmspage";
// import GPMS_Feature from './GPMS_Feature'
import GPMSHowItWorks from "../Component/GPMS/Gpmshowitworks";
import GPMSWhyChoose from "../Component/GPMS/Gpmswhychoose";
import GPMSDeployment from "../Component/GPMS/Gpmsdeployment";
import GPMSAudience from "../Component/GPMS/Gpmsaudience";
// import GPMSFaq from "../Component/GPMS/GPMSFaq";
// import GPMSCta from "../Component/GPMS/GPMSCta";
// import GPMS_Flow from './GPMS_Flow'
// import GPMS_Business_Benefits from './GPMS_Business_Benefits'
import GPMSFaq from "../Component/GPMS/Gpmsfaq";
import GPMSCta from "../Component/GPMS/Gpmscta";


function GPMS_Pro_detail() {
  return (
    <>
    <GPMS_Pro_detail1/>
    {/* <GPMS_Pro_detail2/> */}
    <GPMS_hero/>
    <GPMS_Challenge/>
    <GPMSPage />
    <GPMSHowItWorks />
    <GPMSWhyChoose />
    
    <GPMSAudience/>
    
{/* <GPMS_Solution/> */}
    {/* <GPMS_Pro_detail22/> */}
    {/* <GPMS_Pro_detail3/> */}
    {/* <GPMS_Pro_detail4/> */}
    {/* <GPMS_Pro_detail5/> */}
   {/* <GPMS_Pro_detail6/> */}
   {/* <GPMS_Feature/> */}
   {/* <GPMS_Flow/> */}
   {/* <GPMS_Pro_detail7/> */}
   {/* <GPMS_Pro_detail8/> */}
   {/* <GPMS_Business_Benefits/> */}
   {/* <GPMS_Pro_detail9/> */}
   {/* <GPMS_Pro_detail10/> */}
   {/* <GPMS_Pro_detail12/> */}
   {/* <GPMS_Pro_detail13/>
   <GPMS_Pro_detail11/> */}
   <GPMSDeployment />
   <GPMSFaq />
   <GPMSCta />
   <Gfooter/>
    </>
  )
}

export default GPMS_Pro_detail
